import { classNames } from '@/utils';
import { MD } from '@/types/utils/sizesType';

import type { SocialProfileType } from '@/types/socialProfileType';

// Components
import { DefaultAvatar } from '@/components/base/Avatar';

type SocialProfileMiniDisplayProps = {
    socialProfile: SocialProfileType;
    smaller?: boolean;
    isExport?: boolean;
    className?: string;
};

const SocialProfileMiniDisplay = ({
    socialProfile,
    isExport = false,
    className
}: SocialProfileMiniDisplayProps) => {
    return (
        <div
            className={classNames(
                'mr-1 flex items-center justify-center space-x-0.5 rounded-full bg-white p-[1px]',
                { 'dark:bg-icoDarkMode-anthracite': !isExport },
                className
            )}
            title={socialProfile?.slug ?? ''}>
            <DefaultAvatar
                forceLightMode={isExport}
                url={socialProfile?.external_api_data?.avatar}
                fallback={socialProfile?.slug?.[0]}
                profileType={socialProfile?.social_network_type}
                position="bottom-right"
                size={MD}
            />
        </div>
    );
};

export default SocialProfileMiniDisplay;
